<app-header></app-header>
<app-right-side></app-right-side>
<link href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"  type="text/css" rel="stylesheet" />
<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css" type="text/css" rel="stylesheet" />
<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>
<div class="main-header">
    <div class="content-bg-wrap bg-account"></div>
    <div class="container">
        <div class="row">
            <div class="col col-lg-8 m-auto col-md-8 col-sm-12 col-12">
                <div class="main-header-content">
                    <h1><i class="fad fa-comments"></i> &nbsp;Chat / Rooms</h1>
                </div>
            </div>
        </div>
    </div>
    <img class="img-bottom" src="../../../assets/img/legends-banner.png" alt="friends" style="height: 0px;">
</div>
<div class="container1" [dir]="direction">
  <iframe src="https://deadsimplechat.com/s4lRtf3uN" width="99%" height="600px"></iframe>
  <div style="background-color: black; position: relative; top:-30px; color: black; width:99.5% ; left: 2px;">&nbsp;</div>
</div>

